/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Spec_VersionInputs */

const en_fc_home_spec_version = /** @type {(inputs: Fc_Home_Spec_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest version`)
};

/**
* | output |
* | --- |
* | "Latest version" |
*
* @param {Fc_Home_Spec_VersionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_spec_version = /** @type {((inputs?: Fc_Home_Spec_VersionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Spec_VersionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_spec_version(inputs)
});
export { fc_home_spec_version as "fc.home.spec.version" }